module.exports = {"id":"137832","name":"Diego Cavalieri","rating":"75","photo":"./data/images/photos/2/137832.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoCavalieri0.json
// module id = 1074
// module chunks = 0